// Interfaces para MotorizedService - INFRASEG Engine
// Seguindo as regras do Angular e backend

import { ReportStatus } from '.';

// Enums baseados no schema do Prisma
export enum FuelLevel {
    FULL = 'FULL', // 1 - Tanque cheio
    HALF = 'HALF', // 0.5 - Meio tanque
    EMPTY = 'EMPTY', // 0 - Vazio
}

export enum WorkShift {
    DAY = 'DAY', // Diurno
    NIGHT = 'NIGHT', // Noturno
}

export interface IMotorizedService {
    readonly id: string;
    readonly talaoNumber: number;
    readonly date: Date;
    readonly kmInitial: number;
    readonly kmFinal: number;
    readonly kmTraveled: number;
    readonly fuel: FuelLevel;
    readonly timeInitial: string;
    readonly timeFinal: string;
    readonly workShift: WorkShift;
    readonly status: ReportStatus;
    readonly postId: string;
    readonly streetPatrol: string | null;
    readonly occurrence: string;
    readonly vehicleInspection: string;
    readonly companyId: string;
    readonly vehicleId: string;
    readonly shiftId: string;
    readonly userId: string;
    readonly supervisorId: string;
    readonly createdAt: Date;
    readonly updatedAt: Date;
}

// 🎯 DTO para criação de MotorizedService
export interface ICreateMotorizedServiceDto {
    date: Date | string; // Data do serviço
    kmInitial: number; // Km inicial
    kmFinal?: number; // Km final
    kmTraveled?: number; // Km percorrido (calculado)
    fuel: FuelLevel; // Nível de combustível
    timeInitial: string; // Hora inicial (HH:MM)
    timeFinal?: string; // Hora final (HH:MM)
    workShift: WorkShift; // Turno
    postId: string; // ID do posto
    streetPatrol?: string | null; // Rua/Ronda
    occurrence?: string; // Ocorrência (ocorrência, apoio, portaria)
    vehicleInspection?: string; // Vistoria do veículo
    vehicleId: string; // ID do veículo
    shiftId: string; // ID do turno
    userId?: string; // ID do usuário (motorista)
    supervisorId?: string; // ID do supervisor
    companyId?: string; // ID da empresa
    status: ReportStatus;
    userName?: string; // Nome do motorista
    witnessName?: string; // Nome da testemunha
    supervisorName?: string; // Nome do supervisor
}

// 🎯 DTO para atualização de MotorizedService
export interface IUpdateMotorizedServiceDto extends Partial<ICreateMotorizedServiceDto> {
    id?: string;
}

// 🎯 Response do MotorizedService (para listagem)
export interface IMotorizedServiceResponse extends IMotorizedService {}

// 🎯 Interface para filtros de MotorizedService
export interface IMotorizedServiceFilters {
    readonly page?: number;
    readonly limit?: number;
    readonly search?: string;
    readonly workShift?: WorkShift;
    readonly fuel?: FuelLevel;
    readonly companyId?: string;
    readonly vehicleId?: string;
    readonly shiftId?: string;
    readonly userId?: string;
    readonly dateFrom?: Date;
    readonly dateTo?: Date;
}

// 🎯 Union type para DTOs de MotorizedService
export type MotorizedServiceDto = ICreateMotorizedServiceDto | IUpdateMotorizedServiceDto;
